import { popupsApi } from "./popups.api";

export const { useGetPopupsActiveByCompanyQuery, useSavePopupsReadMutation } = popupsApi;
